export const NULL_BODY_STATUS = [101, 103, 204, 205, 304];

// eslint-disable-next-line n/prefer-global/process
export const IN_WEBCONTAINER = !!globalThis.process?.versions?.webcontainer;
